var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPauseDay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pause"
  }, /*#__PURE__*/React.createElement("path", {
    id: "combo shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0.75C0.895431 0.75 0 1.64543 0 2.75V9.25C0 10.3546 0.89543 11.25 2 11.25H2.5C3.60457 11.25 4.5 10.3546 4.5 9.25V2.75C4.5 1.64543 3.60457 0.75 2.5 0.75H2ZM9.5 0.75C8.39543 0.75 7.5 1.64543 7.5 2.75V9.25C7.5 10.3546 8.39543 11.25 9.5 11.25H10C11.1046 11.25 12 10.3546 12 9.25V2.75C12 1.64543 11.1046 0.75 10 0.75H9.5Z",
    fill: "#556885"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseDay);
export default __webpack_public_path__ + "static/media/pause_day.2268dafcc32da9831b436d4b7cc30f5b.svg";
export { ForwardRef as ReactComponent };